import type { ExcelStyle } from 'ag-grid-community';

export const defaultExcelStyles: ExcelStyle[] = [
  {
    id: 'ag-export-wrap-text',
    alignment: {
      wrapText: true,
    },
  },
  {
    id: 'ag-export-bg-white',
    interior: {
      color: '#ffffff',
      pattern: 'Solid',
    },
  },
  {
    id: 'ag-export-border-left-2px',
    borders: {
      borderLeft: {
        lineStyle: 'Continuous',
        color: '#7d7d7d',
        weight: 2,
      },
    },
  },
  {
    id: 'ag-export-border-right-2px',
    borders: {
      borderRight: {
        lineStyle: 'Continuous',
        color: '#7d7d7d',
        weight: 2,
      },
    },
  },
  {
    id: 'ag-export-border-left-1px',
    borders: {
      borderLeft: {
        lineStyle: 'Continuous',
        color: '#7d7d7d',
        weight: 1,
      },
    },
  },
  {
    id: 'ag-export-border-right-1px',
    borders: {
      borderRight: {
        lineStyle: 'Continuous',
        color: '#7d7d7d',
        weight: 1,
      },
    },
  },
  {
    id: 'ag-export-border-top-1px',
    borders: {
      borderTop: {
        lineStyle: 'Continuous',
        color: '#7d7d7d',
        weight: 1,
      },
    },
  },
  {
    id: 'ag-export-border-bottom-1px',
    borders: {
      borderBottom: {
        lineStyle: 'Continuous',
        color: '#7d7d7d',
        weight: 1,
      },
    },
  },
  {
    id: 'font-bold',
    font: {
      bold: true,
    },
  },
  {
    id: 'header',
    font: {
      bold: true,
    },
  },
  {
    id: 'bg-white',
    interior: {
      color: '#ffffff',
      pattern: 'Solid',
    },
    borders: {
      borderBottom: {
        lineStyle: 'Continuous',
        color: '#ededed',
        weight: 1,
      },
    },
  },
  {
    id: 'white-background',
    interior: {
      color: '#ffffff',
      pattern: 'Solid',
    },
    borders: {
      borderBottom: {
        lineStyle: 'Continuous',
        color: '#ededed',
        weight: 1,
      },
    },
  },
  {
    id: 'gray-lightest-background',
    interior: {
      color: '#f7f7f7',
      pattern: 'Solid',
    },
  },
  {
    id: 'excel-bg-highlighted',
    interior: {
      color: '#f5dacb',
      pattern: 'Solid',
    },
    borders: {
      borderBottom: {
        lineStyle: 'Continuous',
        color: '#ededed',
        weight: 1,
      },
    },
  },
  {
    id: 'bg-highlighted',
    interior: {
      color: '#f5dacb',
      pattern: 'Solid',
    },
    borders: {
      borderBottom: {
        lineStyle: 'Continuous',
        color: '#ededed',
        weight: 1,
      },
    },
  },
  {
    id: 'alignment-indent-0',
    alignment: {
      indent: 2,
    },
    dataType: 'String',
  },
  {
    id: 'alignment-indent-1',
    alignment: {
      indent: 3,
    },
    dataType: 'String',
  },
  {
    id: 'alignment-indent-2',
    alignment: {
      indent: 4,
    },
    dataType: 'String',
  },
  {
    id: 'alignment-indent-3',
    alignment: {
      indent: 5,
    },
    dataType: 'String',
  },
  {
    id: 'alignment-indent-4',
    alignment: {
      indent: 6,
    },
    dataType: 'String',
  },
  {
    id: 'align-right',
    alignment: {
      horizontal: 'Right',
    },
  },
  {
    id: 'ag-wrap-words',
    alignment: {
      wrapText: true,
    },
  },
  {
    id: 'heatmapGreen',
    interior: {
      color: '#c0eb75',
      pattern: 'Solid',
    },
  },
  {
    id: 'heatmapYellow1',
    interior: {
      color: '#ffd43b',
      pattern: 'Solid',
    },
  },
  {
    id: 'heatmapYellow2',
    interior: {
      color: '#fcc419',
      pattern: 'Solid',
    },
  },
  {
    id: 'heatmapYellow3',
    interior: {
      color: '#fab005',
      pattern: 'Solid',
    },
  },
  {
    id: 'heatmapYellow4',
    interior: {
      color: '#f59f00',
      pattern: 'Solid',
    },
  },
  {
    id: 'heatmapRed1',
    interior: {
      color: '#ffa8a8',
      pattern: 'Solid',
    },
  },
  {
    id: 'heatmapRed2',
    interior: {
      color: '#ff8787',
      pattern: 'Solid',
    },
  },
  {
    id: 'heatmapRed3',
    interior: {
      color: '#ff6b6b',
      pattern: 'Solid',
    },
  },
  {
    id: 'heatmapRed4',
    interior: {
      color: '#fa5252',
      pattern: 'Solid',
    },
  },
  {
    id: 'heatmapRed5',
    interior: {
      color: '#f03e3e',
      pattern: 'Solid',
    },
  },
  {
    id: 'heatmapInfinity',
    interior: {
      color: '#9a0606',
      pattern: 'Solid',
    },
  },
  {
    id: 'accounting-number',
    numberFormat: {
      // Formats value to the accounting format
      // * when value is a positive or a negative number with or without euro:
      //   formats with '.' as thousands separator, to 2 decimal places, without euro and with alignment
      // * when value is 0: formats to the '-'
      // * when value is a text: displays as it is
      // https://support.microsoft.com/en-us/office/number-format-codes-5026bbd6-04bc-48cd-bf33-80f18b4eae68
      format: '_-#,##0.00 _€_-;-#,##0.00 _€_-;_-* -?? _€_-;_-@_-',
    },
  },
  {
    id: 'number',
    numberFormat: {
      // Formats value to the number format
      // * when value is a number:
      //   formats with '.' as thousands separator and to 2 decimal places
      // * when value is a text: displays as it is
      // https://support.microsoft.com/en-us/office/number-format-codes-5026bbd6-04bc-48cd-bf33-80f18b4eae68
      format: '#,##0.00;-#,##0.00;@',
    },
  },
  {
    id: 'percent',
    numberFormat: {
      // Formats value to the number format
      // * when value is a number:
      //   formats with '.' as thousands separator and to 2 decimal places
      // * when value is a text: displays as it is
      // https://support.microsoft.com/en-us/office/number-format-codes-5026bbd6-04bc-48cd-bf33-80f18b4eae68
      format: '#,##%;-#,##%;@',
    },
  },
  {
    id: 'excel-index-factor',
    numberFormat: {
      // Formats value to the number format
      // * when value is a number:
      //   formats with '.' as thousands separator and to 3 decimal places
      // * when value is a text: displays as it is
      // https://support.microsoft.com/en-us/office/number-format-codes-5026bbd6-04bc-48cd-bf33-80f18b4eae68
      format: '_-#,###0.000 _€_-;-#,###0.000 _€_-;_-* -?? _€_-;_-@_-',
    },
  },
  {
    id: 'excel-string-type',
    dataType: 'String',
  },
];
